export const mutations = {
  addActiveCategory (state, payload) {
    state.activeCategories.push(payload.categoryId)
  },
  removeActiveCategory (state, payload) {
    state.activeCategories = state.activeCategories.filter(c => c != payload.categoryId)
  },
  clearActiveCategories (state) {
    state.activeCategories = []
  },
  setCategories (state, payload) {
    state.categories = payload.categories
  },
  setActiveCheckpoint (state, payload) {
    state.strolls.activeCheckpoint = payload.checkpoint
  },
  setActiveStroll (state, payload) {
    state.strolls.activeStroll = payload.stroll
  },
  setStrolls (state, payload) {
    state.strolls = payload.strolls
  },
}
